import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e0c05b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-container" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = { class: "left-block" }
const _hoisted_4 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__animated animate__fadeInDown wow"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = {
  "data-wow-duration": "1s",
  class: "techcontext animate__animated animate__fadeInUp wow"
}
const _hoisted_7 = { class: "span" }
const _hoisted_8 = { class: "right-container animate__flipInX wow" }
const _hoisted_9 = { class: "blue-bottom animate__fadeInUp wow" }
const _hoisted_10 = { class: "blue-text" }

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'RDTeam',
  setup(__props) {

const isHover = ref(false)
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Founding Team')), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('subTeam')), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('teamcontent')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('team-blue')), 1)
      ])
    ])
  ]))
}
}

})